<template>
  <transition>
    <div v-if="isShow" name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper" @click="isShow = (isLoading) ? true :  false">
            <div id="content" @click.stop="">
              <h1 class="common__main-title">Select Substitute</h1>
              <div class="content">
                <div v-if="lesson.teacher" class="tutor-content">
                  <div>
                    <p>Tuter Name</p>
                    <h2 class="tutor-name">{{ lesson.teacher.tutor.name }}</h2>
                  </div>
                  <span class="tutor-info">
                    {{ lesson.teacher.tutor.id }} {{ lesson.teacher.tutor.position.name }}
                  </span>
                </div>
                <div class="tutor-status">
                  <p>{{ lesson.date.format('YYYY/MM/DD') }}</p>
                  <p>{{ lesson.university.name }}</p>
                  <p>{{ lesson.campus.name }}</p>
                  <p>Period {{ lesson.period }}</p>
                  <p>{{ lesson.course.name }}</p>
                  <p>{{ lesson.level.name }}</p>
                  <p>{{ lesson.booth | booth }}</p>
                </div>
                <div id="tabBox">
                  <div class="tabs">
                    <input type="radio" value="waiting" id="waiting-tab" v-model="activeTab">
                    <label for="waiting-tab">Waiting List</label>
                    <input type="radio" value="all" id="all-tab" v-model="activeTab">
                    <label for="all-tab">All</label>
                  </div>
                  <ul class="box-contents">
                    <li v-if="activeTab === 'waiting'">
                      <WaitingList
                        :date="lesson.date"
                        :period="lesson.period"
                        v-model="substituteTutor"
                      />
                    </li>
                    <li v-else-if="activeTab === 'all'">
                      <AllList v-model="substituteTutor" />
                    </li>
                  </ul>
                </div>
              </div>
              <div class="select-container">
                <div class="select-container__select-tutor-box">
                  <h3 class="item-title">Selected Tutor Name</h3>
                  <p>{{ substituteTutor && substituteTutor.name }}</p>
                </div>
                <div class="d-flex">
                  <div class="mr-2">
                    <h3 class="item-title">Substitute Time</h3>
                    <select class="substitute-time" v-model="substituteTime">
                      <option :value="null">Provisional</option>
                      <option value="10">10 min</option>
                      <option value="20">20 min</option>
                      <option value="30">30 min</option>
                      <option value="40">40 min</option>
                      <option value="50">50 min</option>
                      <option value="60">60 min</option>
                      <option value="70">70 min</option>
                      <option value="80">80 min</option>
                      <option value="90">90 min</option>
                      <option value="all">All</option>
                    </select>
                  </div>
                  <div class="d-flex align-items-end">
                    <div class="align-bottom mb-4">
                      <label class="checkbox">
                        <input class="mr-1" type="checkbox" v-model="isTrainDelay">
                        Train Delay
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="error-text" v-show="hasError">
                Please select sub substitute tutor
              </div>
              <div class="button-container">
                <div :class="['ok-button', {'disabled': isLoading }]" @click="registerSubstitute">
                  <span v-show="!isLoading">Select</span>
                  <font-awesome-icon v-show="isLoading" icon="spinner" spin />
                </div>
                <div v-if="!this.isLoading" class="cancel-button" @click="isShow=false">Cancel</div>
              </div>
              <span v-if="!this.isLoading" class="chancel-button" @click="isShow=false">
                <font-awesome-icon  icon="times"/>
              </span>
            </div>
          </div>
        </div>
    </div>
  </transition>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import WaitingList from '@/components/parts/modal/tutorList/WaitingList.vue';
import AllList from '@/components/parts/modal/tutorList/AllList.vue';
import _ from 'lodash';
import { Lesson, SubstituteTutor } from '@/store/lessons/types';
import { Booth } from '@/store/booths/types';
import { Tutor } from '@/store/tutors/types';

@Component({
  components: {
    WaitingList,
    AllList,
  },

  filters: {
    booth(b: Booth) {
      return `${b.building} - ${b.room} - ${b.number}`;
    },
  },
})
export default class SelectSubstituteModal extends Vue {
  @Prop() lesson!: Lesson

  private substituteTutor: Tutor|null = null

  private substituteTime: number|null = null

  private isTrainDelay: boolean = false

  private isShow: boolean = false

  private hasError: boolean = false

  private activeTab: string = 'waiting'

  private isLoading: boolean = false

  open(substitute: SubstituteTutor|null) {
    this.substituteTutor = substitute?.tutor || null
    this.substituteTime = substitute?.time || null
    this.isTrainDelay = substitute?.isTrainDelay || false

    this.isShow = true
    this.hasError = false
    this.activeTab = 'waiting'
  }

  close() {
    this.isShow = false;
  }

  /**
   * 代講チューター変更
   * @param {Tutor} tutor チューター
   */
  private changeTutor(tutor: Tutor) {
    this.substituteTutor = tutor;
  }

  // 代講チューター変更
  private registerSubstitute() {
    // 2021年~2023年のデータの場合、登録できないようにする
    if (this.lesson.fiscalYear <= 2023) {
      this.isShow = false;
      this.$bvModal.msgBoxOk('Error - This data from 2021 to 2023 cannot be registered.');
      return;
    }
    if (_.isEmpty(this.substituteTutor)) {
      this.hasError = true;
      return;
    }
    // フル代講の場合、lessonの時間を取得する。
    // eslint-disable-next-line
    //@ts-ignore
    if (this.substituteTime === 'all') {
      this.substituteTime = this.lesson.lessonMinute
    }
    // 登録開始
    const promise = this.$store.dispatch('registerSubstitute', {
      scheduleId: this.lesson.scheduleId,
      tutorId: this.substituteTutor?.id,
      time: Number(this.substituteTime),
      isTrainDelay: this.isTrainDelay,
    })
    this.$emit('startRegisterSubstitute', promise)
  }
}
</script>

<style scoped>

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

#content{
  width: 70%;
  height: 95%;
  z-index:2;
  margin: 0px auto;
  text-align: center;
  padding: 40px;
  background:#fff;
  border-radius: 10px;
  position: relative;
  display: flex;
  transition: all .3s ease;
  flex-direction: column;
  justify-content: space-between;
}

#content .title {
  margin-bottom: 20px;
}

.content{
  padding-right:10px;
  margin:auto;
  margin-bottom:40px;
  width:100%;
  overflow-x: hidden;
  overflow-y: scroll;
}

.content::-webkit-scrollbar{
  width: 15px;
}

.content::-webkit-scrollbar-track{
  background: #fff;
  border: none;
  border-radius: 10px;
  box-shadow: inset 0 0 2px #777;
}
.content::-webkit-scrollbar-thumb{
  background: #D8D8D8;
  border-radius: 10px;
  box-shadow: none;
}

.ok-button, .cancel-button {
  color: #fff;
  padding:10px 30px;
  border-radius: 30px;
  display: block;
  width: 20%;
  margin:auto;
  cursor: pointer;
  transition:.2s;
  font-size: 13px;
  text-align: center;
}

.ok-button{
  border: 3px solid #1cc8a0;
  background: #1cc8a0;
}

.ok-button:hover {
  background: #fff;
  color:#1cc8a0;
}

.cancel-button{
  border: 3px solid #eee;
  background: #eee;
  color:#000;
}

.cancel-button:hover{
  background: #D8D8D8;
}

.chancel-button {
  position: absolute;
  top: 15px;
  right: 15px;
  cursor: pointer;
  line-height: 20px;
  font-size: 20px;
}

.chancel-button:hover {
  opacity:.5;
}

.button-container {
  display: flex;
  margin-top:40px;
}

.tutor-status {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding:20px;
  background: #D8D8D8;
  margin-bottom:50px;
}

.tutor-status p{
  margin-right:20px;
  font-size: 20px;
  line-height: 30px;
}

select.substitute-time {
  padding: 5px;
  border: 1px solid #AAAFB6;
  border-radius: 30px;
  width: 200px;
  height: 30px;
  box-sizing: border-box;
  margin-bottom: 20px;
}

.item-title {
  font-size: 1.5em;
  margin-bottom:10px;
}

.select-container {
  display: flex;
  justify-content: center;
}

.select-container__select-tutor-box {
  margin-right:70px;
}

.select-container__select-tutor-box p {
  padding: 5px;
  border-radius: 30px;
  height: 30px;
  box-sizing: border-box;
  margin-bottom: 20px;
  font-size: 20px;
  line-height: 20px;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter #content,
.modal-leave-active #content {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.tutor-content {
  background: #D8D8D8;
  padding:40px 20px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.tutor-name {
  line-height: 25px;
  font-size:25px;
  margin-bottom:10px;
}

.tutor-info {
  padding: 5px 10px;
  border-radius: 20px;
  background: #2E75B5;
  color: #fff;
}

.tutor-content p {
  text-align: left;
  margin-bottom: 5px;
}

ul {
  padding: 0;
  margin: 0;
}

li {
  list-style: none;
}

.tabs {
  overflow: hidden;
  display: flex;
  margin-left: 30px;
}

.tabs input {
  display: none;
}

.tabs label {
  display: inline-block;
  line-height: 40px;
  width: 150px;
  text-align: center;
  cursor: pointer;
  background: #1cc8a0;
  color: #fff;
  transition: 0.3s ease-in-out;
  border-radius: 10px 10px 0 0;
}

.tabs input:checked + label,
.tabs label:hover {
  background: #D8D8D8;
  color: #000;
}

.box-contents {
  padding: 40px;
  min-height:500px;
  margin-bottom:20px;
  border:1px solid #d8d8d8;
}

.checkbox {
  display: flex;
  align-items: center;
  margin-bottom: 0;
}
</style>
